import styled from 'react-emotion';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const Wrapper = styled.div`
  background: ${colors.white};
  border-radius: ${theme.borderRadius.medium};
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12),
    0px 1px 8px rgba(0, 0, 0, 0.2);
  margin-left: 12px;
  max-width: 240px;
  margin-top: 32px;
  height: max-content;
  max-height: 720px;
  min-height: 90px;
  overflow: hidden;
  position: relative;
  padding-bottom: ${({ noFetchedPosts }) => (noFetchedPosts ? 0 : '50px')};
  width: 100%;
`;

export const SideBarTitle = styled.div`
  align-items: center;
  color: ${colors.designSystem.blackOpacity87};
  display: flex;
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.large};
  font-weight: ${theme.font.weight.semiBold};
  line-height: ${theme.font.lineHeight.copy};
  padding: 14px;

  span {
    margin-left: 14px;
  }
`;

export const SideBarFooter = styled.div`
  background: ${colors.white};
  bottom: 7px;
  padding: 0 ${theme.spacing.small}
    ${({ noFetchedPosts }) =>
      noFetchedPosts ? theme.spacing.xxSmall : theme.spacing.small};
  position: absolute;
  width: 90%;
`;

export const FooterLink = styled.p`
  color: ${colors.designSystem.purple70};
  margin: 0;
  padding-top: ${theme.spacing.small};
  text-align: right;
`;

export const TextButtonStyles = {
  fontFamily: theme.font.family.workSans,
  fontSize: theme.font.size.copy,
  fontWeight: theme.font.weight.semiBold,
  lineHeight: '16px',
  '&:hover': {
    textDecoration: 'none',
  },
  '&:active': {
    textDecoration: 'none',
  },
};
